// ==========================================================================
// SOUS-THÈMES POUR LES TÂCHES
// Structure :
//   - array de strings => liste simple
//   - { grouped: true, groups: [{ label, items }] } => liste avec sections
// ==========================================================================

export const TASK_SUBTHEMES = {
  travail: {
    grouped: true,
    groups: [
      {
        label: '⚖️ Procédure & Contentieux',
        items: [
          'Audience',
          'Plaidoirie',
          'Rédaction conclusions',
          'Rédaction assignation',
          'Rédaction requête',
          'Mise en état',
          'Référé',
          'Appel',
          'Pourvoi en cassation',
          'Exécution de jugement',
          'Saisie / Procédure civile d\'exécution',
        ],
      },
      {
        label: '💬 Conseil & Consultation',
        items: [
          'Consultation juridique',
          'Rendez-vous client',
          'Premier contact / Entretien initial',
          'Étude de pièces / Analyse dossier',
          'Note juridique',
          'Avis juridique',
          'Audit juridique',
        ],
      },
      {
        label: '📝 Rédaction d\'actes',
        items: [
          'Contrat / Convention',
          'Bail',
          'Transaction / Protocole',
          'Statuts / Pacte d\'associés',
          'Mise en demeure',
          'Courrier officiel',
          'Testament / Donation',
          'Convention de divorce',
        ],
      },
      {
        label: '🤝 Négociation & Médiation',
        items: [
          'Négociation',
          'Médiation',
          'Conciliation',
          'Procédure participative',
        ],
      },
      {
        label: '📞 Relation client',
        items: [
          'Appel téléphonique client',
          'Compte-rendu au client',
          'Rendez-vous signature',
          'Envoi de pièces',
          'Relance client',
        ],
      },
      {
        label: '📂 Démarches & Procédural',
        items: [
          'Dépôt au greffe',
          'Signification / Huissier',
          'Suivi de procédure',
          'Calcul de délais',
          'Demande de pièces',
          'Communication de pièces',
          'Aide juridictionnelle',
        ],
      },
      {
        label: '🔍 Recherche & Veille',
        items: [
          'Recherche juridique',
          'Jurisprudence',
          'Doctrine',
          'Veille juridique',
        ],
      },
      {
        label: '🏢 Cabinet & Administratif',
        items: [
          'Administratif cabinet',
          'Facturation / Honoraires',
          'Provision',
          'Comptabilité / CARPA',
          'Gestion des collaborateurs',
          'Archivage de dossier',
          'Ouverture de dossier',
          'Clôture de dossier',
        ],
      },
      {
        label: '🎓 Formation & Ordre',
        items: [
          'Formation',
          'Colloque / Congrès',
          'Webinaire',
          'Lecture professionnelle',
          'Ordre des avocats / CNB',
          'Déontologie',
        ],
      },
      {
        label: '➕ Autre',
        items: ['Autre'],
      },
    ],
  },

  enfants: [
    'École',
    'Devoirs',
    'Activité extrascolaire',
    'Anniversaire',
    'Rendez-vous médical',
    'Garde',
    'Sortie',
    'Habillement',
    'Autre',
  ],

  maison: [
    'Ménage',
    'Bricolage / Travaux',
    'Jardinage',
    'Cuisine',
    'Rangement / Tri',
    'Factures / Énergie',
    'Décoration',
    'Autre',
  ],

  administratif: [
    'Impôts',
    'Banque',
    'Assurance',
    'Santé / Mutuelle',
    'Documents officiels',
    'Abonnements',
    'Courrier',
    'Autre',
  ],

  perso: [
    'Santé',
    'Beauté',
    'Social',
    'Loisirs',
    'Développement personnel',
    'Cadeaux à acheter',
    'Voyage',
    'Autre',
  ],
};

// ==========================================================================
// SOUS-THÈMES POUR LES ÉVÉNEMENTS (calendrier)
// ==========================================================================
export const EVENT_SUBTHEMES = {
  travail: {
    grouped: true,
    groups: [
      {
        label: '⚖️ Audiences & Procédure',
        items: ['Audience', 'Plaidoirie', 'Référé', 'Mise en état', 'Conciliation'],
      },
      {
        label: '💬 Rendez-vous',
        items: ['Rendez-vous client', 'Premier contact', 'Signature client', 'Rendez-vous confrère'],
      },
      {
        label: '🤝 Négociation',
        items: ['Médiation', 'Négociation', 'Réunion contradictoire'],
      },
      {
        label: '🏢 Cabinet',
        items: ['Réunion équipe', 'Administratif cabinet'],
      },
      {
        label: '🎓 Formation',
        items: ['Formation', 'Colloque / Congrès', 'Webinaire', 'Ordre des avocats'],
      },
      {
        label: '➕ Autre',
        items: ['Autre'],
      },
    ],
  },
  enfants: ['École', 'Activité extrascolaire', 'Anniversaire', 'Rendez-vous médical', 'Sortie', 'Autre'],
  sport: ['Séance individuelle', 'Cours collectif', 'Compétition', 'Autre'],
  medical: ['Médecin généraliste', 'Spécialiste', 'Dentiste', 'Ophtalmo', 'Analyses', 'Autre'],
  social: ['Dîner', 'Anniversaire', 'Soirée', 'Déjeuner', 'Autre'],
  autre: ['Autre'],
};

export const NOTE_SUBTHEMES = TASK_SUBTHEMES;

// ==========================================================================
// HELPERS — rendu et extraction
// ==========================================================================

// Renvoie true si la structure est groupée
export function isGrouped(subthemes) {
  return subthemes && !Array.isArray(subthemes) && subthemes.grouped;
}

// Renvoie la liste plate (utile pour les filtres qui ne supportent pas les optgroups)
export function flattenSubthemes(subthemes) {
  if (!subthemes) return [];
  if (Array.isArray(subthemes)) return subthemes;
  if (subthemes.grouped) return subthemes.groups.flatMap(g => g.items);
  return [];
}

// ==========================================================================
// LIBELLÉS DE RÉFÉRENCE
// ==========================================================================
export const REFERENCE_LABEL = {
  travail: 'Nom du dossier',
  enfants: 'Enfant concerné',
  maison: 'Pièce / zone (optionnel)',
  administratif: 'Organisme / Dossier',
  perso: 'Contexte (optionnel)',
  sport: 'Club / Lieu (optionnel)',
  medical: 'Praticien / Lieu (optionnel)',
  social: 'Avec qui (optionnel)',
  autre: 'Référence (optionnel)',
};

export const REFERENCE_PLACEHOLDER = {
  travail: 'Ex : Dupont c/ Martin',
  maison: 'Ex : Salon, Cuisine',
  administratif: 'Ex : Impôts 2026, AXA habitation',
  perso: 'Ex : Anniv maman',
  sport: 'Ex : Salle FitForm',
  medical: 'Ex : Dr Dupuis',
  social: 'Ex : Famille Martin',
  autre: '',
};

export const REFERENCE_REQUIRED = {
  travail: true,
};

export const CATEGORIES_USING_CHILD_DROPDOWN = ['enfants'];

export const TASK_CATEGORIES = [
  { value: 'travail', label: 'Travail', emoji: '💼' },
  { value: 'maison', label: 'Maison', emoji: '🏠' },
  { value: 'enfants', label: 'Enfants', emoji: '👶' },
  { value: 'administratif', label: 'Administratif', emoji: '📄' },
  { value: 'perso', label: 'Perso', emoji: '🌟' },
];

export const EVENT_CATEGORIES = [
  { value: 'travail', label: 'Travail', color: '#3b82f6' },
  { value: 'enfants', label: 'Enfants', color: '#ec4899' },
  { value: 'sport', label: 'Sport', color: '#f97316' },
  { value: 'medical', label: 'Médical', color: '#ef4444' },
  { value: 'social', label: 'Social', color: '#8b5cf6' },
  { value: 'autre', label: 'Autre', color: '#6366f1' },
];

// ==========================================================================
// TYPES DE PRESTATIONS (repris de Bill4Time) — pour le champ "Type d'activité"
// ==========================================================================
export const PRESTATION_ACTIVITIES = [
  'Assemblée générale, convocation',
  'Assemblée générale, préparation',
  'Assemblée générale, procès-verbal',
  'Assemblée générale, réunion',
  'Avis circonstancié écrit',
  'Avis circonstancié écrit, étude',
  'Avis circonstancié écrit, préparation',
  'Avis circonstancié écrit, rédaction',
  'Avis circonstancié écrit, révision',
  "Conseil d'administration, convocation",
  "Conseil d'administration, préparation",
  "Conseil d'administration, procès-verbal",
  "Conseil d'administration, réunion",
  'Constat',
  'Constat, étude',
  'Constat, préparation',
  "Constat, réunion avec l'huissier",
  'Convention',
  'Convention : Avenant',
  'Convention : Conditions générales',
  'Convention : Contrat de bail',
  'Convention : Contrat de transaction',
  'Convention : Contrat de vente',
  'Convention : Mandat',
  'Convention : Reconnaissance de dette',
  'Convention : Statuts de société',
  'Convention, étude',
  'Convention, négociations',
  'Convention, préparation',
  'Convention, rédaction',
  'Convention, révision',
  'Correspondance',
  'Correspondance : Mise en demeure',
  'Correspondance : Projet de lettre',
  "Correspondance à l'avocat adverse",
  "Correspondance à l'expert",
  "Correspondance à l'huissier",
  'Correspondance à la partie adverse',
  'Correspondance au client',
  'Correspondance au conseiller technique',
  'Correspondance au curateur',
  "Correspondance au Juge d'instruction",
  'Correspondance au notaire',
  'Correspondance au Parquet',
  'Correspondance au Tribunal',
  'Correspondance, prise de connaissance',
  'Démarche',
  'Déplacement',
  'Dossier répressif',
  'Dossier répressif, commande de copies',
  'Dossier répressif, étude',
  'Dossier répressif, étude au greffe',
  'Dossier répressif, synthèse',
  'Entretien téléphonique',
  "Entretien téléphonique avec l'avocat adverse",
  "Entretien téléphonique avec l'expert",
  "Entretien téléphonique avec l'huissier",
  'Entretien téléphonique avec la partie adverse',
  'Entretien téléphonique avec le client',
  'Entretien téléphonique avec le curateur',
  'Entretien téléphonique avec le greffe',
  'Entretien téléphonique avec le notaire',
  'Entretien téléphonique avec le Parquet',
  'Entretien téléphonique, préparation',
  'Etude : Documentation et pièces',
  'Etude : Eléments complémentaires',
  'Etude : Eléments initiaux',
  'Etude : Législation, Doctrine, Jurisprudence',
  'Expertise',
  'Expertise, assistance à une réunion',
  'Expertise, constitution du dossier',
  'Expertise, étude de la note de la partie adverse',
  'Expertise, étude des préliminaires',
  'Expertise, étude du rapport',
  'Expertise, note de faits directoires',
  "Expertise, observations à l'expert",
  "Expertise, préparation d'une réunion",
  'Formulaire',
  'Formulaire : Consultation du registre national',
  'Formulaire : Déclaration de créance',
  'Formulaire : Publication au Moniteur belge',
  'Gestion comptable',
  'Première consultation : Entretien téléphonique',
  'Première consultation : Réunion au cabinet',
  'Première consultation : Visioconférence',
  'Procédure : Audience',
  "Procédure : Audience d'introduction",
  'Procédure : Audience de plaidoiries',
  'Procédure : Audience de prononcé',
  'Procédure : Audience de remise',
  'Procédure : Audience, préparation',
  'Procédure : Citation',
  'Procédure : Citation, étude',
  'Procédure : Citation, préparation',
  'Procédure : Citation, rédaction',
  'Procédure : Citation, révision',
  'Procédure : Conclusions',
  'Procédure : Conclusions, dépôt',
  'Procédure : Conclusions, étude',
  'Procédure : Conclusions, préparation',
  'Procédure : Conclusions, rédaction',
  'Procédure : Conclusions, révision',
  'Procédure : Dossier de pièces',
  'Procédure : Dossier de pièces, constitution',
  'Procédure : Dossier de pièces, dépôt',
  'Procédure : Dossier de pièces, étude',
  'Procédure : Dossier de pièces, inventaire',
  'Procédure : Dossier de pièces, révision',
  'Procédure : Faillite',
  'Procédure : Jugement',
  'Procédure : Plainte',
  'Procédure : Plainte, dépôt',
  'Procédure : Plainte, étude',
  'Procédure : Plainte, préparation',
  'Procédure : Plainte, rédaction',
  'Procédure : Plainte, révision',
  'Procédure : Requête',
  'Procédure : Requête, dépôt',
  'Procédure : Requête, étude',
  'Procédure : Requête, préparation',
  'Procédure : Requête, rédaction',
  'Procédure : Requête, révision',
  'Recherche : Documentation',
  'Recherche : Législation, Doctrine, Jurisprudence',
  'Réunion',
  "Réunion avec l'avocat adverse",
  'Réunion avec la partie adverse',
  'Réunion avec le client',
  'Réunion avec le conseiller technique',
  'Réunion avec le curateur',
  'Réunion avec le notaire',
  'Réunion, compte-rendu',
  'Réunion, préparation',
  'Secrétariat',
  'Secrétariat : Avocats',
  'Secrétariat : Avocats - Accueil',
  'Secrétariat : Avocats - Copie',
  'Secrétariat : Avocats - Courrier',
  'Secrétariat : Avocats - Démarche',
  'Secrétariat : Avocats - Téléphone',
  'Traduction',
  'Visioconférence',
];

// Types de frais (débours) importés de Bill4Time — avec montant par défaut (modifiable)
export const EXPENSE_TYPES = [
  { name: 'Frais de copie', amount: 0.30 },
  { name: 'Frais de correspondance', amount: 10.00 },
  { name: 'Frais de dactylographie', amount: 10.00 },
  { name: 'Frais de déplacement', amount: 0.40 },
  { name: 'Frais de greffe', amount: null },
  { name: 'Frais de rappel', amount: 30.00 },
  { name: 'Frais de recommandé', amount: 15.00 },
  { name: 'Frais de registre national', amount: 7.50 },
  { name: 'Frais de téléphonie', amount: null },
  { name: 'Frais de traduction', amount: null },
  { name: "Frais d'huissier", amount: null },
  { name: "Frais d'impression", amount: 0.30 },
  { name: 'Frais divers', amount: null },
  { name: "Frais d'ouverture et de clôture", amount: 50.00 },
];

// Catégories de dossiers (Bill4Time) — pour un futur champ "type de dossier"
export const DOSSIER_TYPES = [
  'Assurances & responsabilité', 'Autre', 'Baux', 'Construction', 'Copropriété',
  'Dommage corporel', 'Droit commercial', 'Droit des sociétés', 'Droit du travail',
  'Droit familial : Autre', 'Droit familial : Divorce', 'Droit pénal : autre',
  'Droit pénal : roulage', 'Droit social', 'Faillite & PRJ', 'Immobilier',
  'Recouvrement de créances', 'Succession', 'Transport', 'Urbanisme',
];
